var d3wl = {};

//Public Methods
d3wl.transform = function (transform) {

	if (transform === undefined || transform === null) {
		return {
			translateX: 0,
			translateY: 0,
			rotate: 0,
			skewX: 0,
			scaleX: 1,
			scaleY: 1,
			translate: [0, 0],
			scale: [1, 1]
		}
	}

	//https://stackoverflow.com/questions/38224875/replacing-d3-transform-in-d3-v4
	// Create a dummy g for calculation purposes only. This will never
	// be appended to the DOM and will be discarded once this function
	// returns.
	var g = document.createElementNS("http://www.w3.org/2000/svg", "g");

	// Set the transform attribute to the provided string value.
	g.setAttributeNS(null, "transform", transform);

	// consolidate the SVGTransformList containing all transformations
	// to a single SVGTransform of type SVG_TRANSFORM_MATRIX and get
	// its SVGMatrix.
	var matrix = null
	if (g.transform.baseVal.consolidate() !== null)
		matrix = g.transform.baseVal.consolidate().matrix;
	else if (g.transform.baseVal.length !== 0)
		matrix = g.transform.baseVal[0].matrix;
	else return null

	// Below calculations are taken and adapted from the private function
	// transform/decompose.js of D3's module d3-interpolate.
	var {
		a,
		b,
		c,
		d,
		e,
		f
	} = matrix; // ES6, if this doesn't work, use below assignment
	// var a=matrix.a, b=matrix.b, c=matrix.c, d=matrix.d, e=matrix.e, f=matrix.f; // ES5
	var scaleX, scaleY, skewX;
	if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	return {
		translateX: e,
		translateY: f,
		rotate: Math.atan2(b, a) * 180 / Math.PI,
		skewX: Math.atan(skewX) * 180 / Math.PI,
		scaleX: scaleX,
		scaleY: scaleY,
		translate: [e, f],
		scale: [scaleX, scaleY]
	};
};

d3wl.rebind = function (target, source) {
	//https://stackoverflow.com/questions/47844765/d3-rebind-in-d3-v4
	var i = 1,
		n = arguments.length,
		method;
	while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	return target;
};

//Private Methods
function d3_rebind(target, source, method) {
	return function () {
		var value = method.apply(source, arguments);
		return value === source ? target : value;
	};
}

// Emulation of PrototypeJS’ Element.getDimensions() method
d3wl.dimensions = function(selection) {
	var dim;
	var element = selection.node();
	var display = selection.style('display');

	var getDimensions = function(e) {
		if (e.getBBox) {
			var box = e.getBBox();
			return [box.width, box.height];
		}

		return [e.offsetWidth, e.offsetHeight];
	};

	if (display && display !== 'none') {
		dim = getDimensions(element);
		return { width: dim[0], height: dim[1] };
	}

	var style = element.style;

	var originalStyles = {
		visibility: style.visibility,
		position:   style.position,
		display:    style.display
	};

	var newStyles = {
		visibility: 'hidden',
		display:    'block'
	};

	if (originalStyles.position !== 'fixed') {
		newStyles.position = 'absolute';
	}

	selection.style(newStyles);

	dim = getDimensions(element);

	var dimensions = {
		width:  dim[0],
		height: dim[1]
	};

	selection.style(originalStyles);

	return dimensions;
}

export default d3wl;
